import "./FeedbackForm.css";
import { forwardRef, useContext, useImperativeHandle, useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { UploadMultipleFiles } from "../../Components/services/apiFunctions";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faPaperclip } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { AppContext } from "../../AppContext";

const FeedbackForm = forwardRef((props, ref) => {
  const [appContext, dispatch] = useContext(AppContext);

  const [name, setName] = useState(
    appContext.isLoggedIn ? sessionStorage.getItem("name") : null
  );
  const [email, setEmail] = useState(
    appContext.isLoggedIn ? sessionStorage.getItem("email") : null
  );

  const [feedbackType, setFeedbackType] = useState(null);
  const [feedbackCategory, setFeedbackCategory] = useState(null);
  const [feedbackContent, setFeedbackContent] = useState(null);

  const [userNameErrorMsg, setUserNameErrorMsg] = useState(false);
  const [userEmailErrorMsg, setUserEmailErrorMsg] = useState(false);
  const [feedbackTypeErrorMsg, setFeedbackTypeErrorMsg] = useState(false);
  const [feedbackCategoryErrorMsg, setFeedbackCategoryErrorMsg] =
    useState(false);
  const [feedbackContentErrorMsg, setFeedbackContentErrorMsg] = useState(false);

  const [showFileSizeExceedError, setShowFileSizeExceedError] = useState(false);
  const [showFileExtensionError, setShowFileExtensionError] = useState(false);
  const [UploadDocumentPath, setUploadDocumentPath] = useState(null);
  const [UploadDocumentVal, setUploadDocumentVal] = useState(null);

  const [DocumentPath, SetDocumentPath] = useState([]);

  const feedbackTypes = [
    "Defect",
    "Enchancement",
    "Inquery/Feedback",
    "Change Request",
  ];
  const feedbackTypesValues = feedbackTypes.map((element) => {
    return { value: element, label: element };
  });

  const feedbackCategories = ["Persona", "Events", "Features", "Others"];

  const feedbackCategoryValues = feedbackCategories.map((element) => {
    return { value: element, label: element };
  });

  useImperativeHandle(ref, () => ({
    feedbackReset() {
      setName(appContext.isLoggedIn ? sessionStorage.getItem("name") : null);
      setEmail(appContext.isLoggedIn ? sessionStorage.getItem("email") : null);
      setFeedbackType(null);
      setFeedbackCategory(null);
      setFeedbackContent(null);
      setUserNameErrorMsg(false);
      setUserEmailErrorMsg(false);
      setFeedbackTypeErrorMsg(false);
      setFeedbackCategoryErrorMsg(false);
      setFeedbackContentErrorMsg(false);
      setShowFileSizeExceedError(false);
      setShowFileExtensionError(false);
      setUploadDocumentPath(null);
    },
    async feedbackSubmit() {
      try {
        if (feedbackType === null) {
          setFeedbackTypeErrorMsg(true);
        }

        if (feedbackCategory === null) {
          setFeedbackCategoryErrorMsg(true);
        }
        if (feedbackContent === null) {
          setFeedbackContentErrorMsg(true);
        }

        if (name === null) {
          setUserNameErrorMsg(true);
        }

        if (email === null) {
          setUserEmailErrorMsg(true);
        }

        if (
          (feedbackType &&
            feedbackCategory &&
            feedbackContent &&
            name &&
            email) ||
          (UploadDocumentPath === null &&
            feedbackType &&
            feedbackType.value === "Defect")
        ) {
          let payload = {
            name: appContext.isLoggedIn ? sessionStorage.getItem("name") : name,
            email: appContext.isLoggedIn
              ? sessionStorage.getItem("email")
              : email,
            type: feedbackType.value,
            category: feedbackCategory.value,
            description: feedbackContent,
            documentPath: UploadDocumentPath,
            createdBy: sessionStorage.getItem("empId"),
          };
          return { validation: true, data: payload };
        } else {
          return { validation: false, data: {} };
        }
      } catch (error) {
        toast.error("Something went wrong");
        console.log(error);
      }
    },
  }));

  const handleFeedbackType = (e) => {
    var feedbacktype = e;
    if (feedbacktype === null || feedbacktype.length == 0) {
      setFeedbackTypeErrorMsg(true);
    } else {
      setFeedbackTypeErrorMsg(false);
      setFeedbackType(e);
    }
  };

  const handleFeedbackCategory = (e) => {
    var feedbackcategory = e;
    if (feedbackcategory === null || feedbackcategory.length == 0) {
      setFeedbackCategoryErrorMsg(true);
    } else {
      setFeedbackCategoryErrorMsg(false);
      setFeedbackCategory(e);
    }
  };

  const UploadDocument = async (eve) => {
    let filesref = [];
    let selectedFiles = [];
    selectedFiles = eve.target.files;
    if (eve.target.files.length != 0) {
      if (eve.target.files.length > 5) {
        toast.warning("Maximum 5 files can be uploaded");
        setUploadDocumentPath(null);
        setUploadDocumentVal("");
        return;
      }
      Array.from(eve.target.files).forEach((element) => {
        const extension = element.name.split(".").pop();
        const isSupported = [
          "pdf",
          "ppt",
          "pptx",
          "doc",
          "docx",
          "png",
          "jpg",
          "jpeg",
        ].includes(extension);
        if (isSupported) {
          if (eve.target.files[0].size > 4000000) {
            setShowFileSizeExceedError(true);
            setUploadDocumentPath(null);
            // setLoader(false);
            return;
          }
          setShowFileSizeExceedError(false);
          setShowFileExtensionError(false);
        } else {
          setShowFileExtensionError(true);
          setUploadDocumentPath(null);
          setUploadDocumentVal("");
        }
        if (
          extension === "pdf" ||
          extension === "ppt" ||
          extension === "pptx" ||
          extension === "doc" ||
          extension === "docx" ||
          extension === "png" ||
          extension === "jpg" ||
          extension === "jpeg"
        ) {
          var obj = {};
          obj.file = element;
          filesref.push(obj);
        }
      });

      if (
        showFileSizeExceedError === false &&
        showFileExtensionError === false
      ) {
        try {
          const response = await UploadMultipleFiles(
            filesref,
            "FeedbackDocument"
          );
          if (response.status == 200) {
            console.log("response", response);
            const document = [];
            Array.from(eve.target.files).forEach((element, index) => {
              const obj = {
                azurepath: response?.data[index],
                FileName: element.name,
              };
              document.push(obj);
            });
            SetDocumentPath(document);
            var b = response.data.join(", ");
            setUploadDocumentPath(b);
          } else {
            setUploadDocumentPath(null);
            setUploadDocumentVal("");
          }
        } catch (error) {
          setUploadDocumentPath(null);
          setUploadDocumentVal("");
        }
      } else {
        setUploadDocumentPath(null);
        setUploadDocumentVal("");
      }
    } else {
      return;
    }
  };

  return (
    <div id="feedbackcontainer">
      <div className="col-12" id="feedbackcontainer">
        <form
          name="feedbackform"
          id="feedbackform"
          className="feedback"
          encType="multipart/form-data"
        >
          <div className="row pe-3 ps-3 col-12 mt-2">
            <div className="col-11">
              <Form.Label>
                <strong>
                  Name
                  <span className="text-danger">*</span>
                </strong>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Please type your name"
                className="form-control"
                onChange={(e) => setName(e.target.value)}
                value={name}
                maxLength={100}
                disabled={appContext.isLoggedIn}
                isInvalid={!!userNameErrorMsg}
              />
            </div>
            {userNameErrorMsg && (
              <div className="errorMsg pe-3 ps-3">Please type your name</div>
            )}
          </div>
          <div className="row pe-3 ps-3 col-12 mt-2">
            <div className="col-11">
              <Form.Label>
                <strong>
                  Email
                  <span className="text-danger">*</span>
                </strong>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Please type your email"
                className="form-control"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                maxLength={100}
                disabled={appContext.isLoggedIn}
                isInvalid={!!userEmailErrorMsg}
              />
            </div>
            {userEmailErrorMsg && (
              <div className="errorMsg pe-3 ps-3">Please type your email</div>
            )}
          </div>
          <div className="row pe-3 ps-3 col-12 mt-2">
            <div className="col-11">
              <Form.Label>
                <strong>
                  Feedback Type
                  <span className="text-danger">*</span>
                </strong>
              </Form.Label>
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="feedbacktooltip" className="feedbacktooltip">
                    <table>
                      <tr className="pb-1">
                        <td>Defect</td>
                        <td>:</td>
                        <td className="ps-1">
                          When the functionality is not working as per the
                          designed feature.
                        </td>
                      </tr>
                      <tr className="pb-1">
                        <td>Enhancement</td>

                        <td>:</td>
                        <td className="ps-1">
                          New feature request that is not part of existing
                          functionality or logic.
                        </td>
                      </tr>
                      <tr className="pb-1">
                        <td>Change Request</td>
                        <td>:</td>
                        <td className="ps-1">
                          Any modification to the existing functionality.
                        </td>
                      </tr>
                      <tr className="pb-1">
                        <td>Inquiry/Feedback</td>
                        <td>:</td>
                        <td className="ps-1">
                          Any general inquiry or a positive feedback
                        </td>
                      </tr>
                    </table>
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={faInfoCircle} className="faInfoCircle" />
              </OverlayTrigger>
              <Select
                className={feedbackTypeErrorMsg && "addskillredborder"}
                options={feedbackTypesValues}
                placeholder="Select the Feedback Type"
                value={feedbackType}
                onChange={handleFeedbackType}
              />
            </div>
            {feedbackTypeErrorMsg && (
              <div className="errorMsg pe-3 ps-3">
                Select an appropriate feedback type
              </div>
            )}
          </div>

          <div className="row pe-3 ps-3 col-12 mt-2">
            <div className="col-11">
              <Form.Label>
                <strong>
                  Category
                  <span className="text-danger">*</span>
                </strong>
              </Form.Label>
              <Select
                className={feedbackCategoryErrorMsg && "addskillredborder"}
                options={feedbackCategoryValues}
                placeholder="Select the Category"
                value={feedbackCategory}
                onChange={handleFeedbackCategory}
              />
            </div>
            {feedbackCategoryErrorMsg && (
              <div className="errorMsg pe-3 ps-3">
                Select an appropriate feedback category
              </div>
            )}
          </div>

          <div className="row pe-3 ps-3 col-12 mt-2">
            <div className="col-11">
              <Form.Label>
                <strong>
                  Description
                  <span className="text-danger">*</span>
                </strong>
              </Form.Label>
              <span className="float-end">
                {feedbackContent == undefined ? 0 : feedbackContent.length} /
                8000
              </span>
              <Form.Control
                as="textarea"
                rows={4}
                cols={200}
                placeholder="Your detailed feedback here..."
                id="description"
                className="form-control"
                maxLength={8000}
                onChange={(e) => setFeedbackContent(e.target.value)}
                value={feedbackContent}
                isInvalid={!!feedbackContentErrorMsg}
              />
            </div>

            {feedbackContentErrorMsg && (
              <div className="errorMsg pe-3 ps-3">
                Please leave your comments
              </div>
            )}
          </div>

          <div className="row pe-3 ps-3 col-12 pt-3">
            <div className="d-flex flex-row col-auto text-left pb-2">
              <FontAwesomeIcon icon={faPaperclip} className="faPaperClip" />
              <input
                size="sm"
                type="file"
                className="form-control-file custom-feedback-attachment border-0"
                id="files"
                accept=".pdf,.ppt, .pptx,.doc,.docx,.png,.jpg,.jpeg"
                onChange={UploadDocument}
                multiple
                value={UploadDocumentVal}
                style={{ marginRight: "10rem" }}
              />
            </div>
            {feedbackType === "Defect" && (
              <div className="col-4 text-left pb-2 ps-0 red">*</div>
            )}
            {showFileSizeExceedError && (
              <div className=" row errorMsg pe-3 ps-4 col-12">
                Please select a file less than 4MB
              </div>
            )}
            {showFileExtensionError && (
              <div className="row errorMsg pe-3 ps-4 col-12">
                Unsupported file format (Please upload files with extensions
                docx,pdf,png,jpg,jpeg,gif,bmp,pptx)
              </div>
            )}
            {UploadDocumentPath === null &&
              feedbackType &&
              feedbackType.value === "Defect" && (
                <div className="row errorMsg pe-3 ps-3">
                  Please attach the screenshot. Mandatory for defect.
                </div>
              )}
            <div className="pe-3 ps-4 mt-1 custom-feedbackNote row col-12">
              <table>
                <tr>
                  <td>
                    <p className="fontx12">
                      <u>Note</u>: Please furnish all the required details above
                      (For ex: Description including snapshot with timestamp &
                      keyword (if any))
                      <br />
                      <span className="ps-4 ms-1">
                        File should not be larger than 4 MB. Only Image files,
                        .docx, .pptx and .pdf files are allowed.
                      </span>
                    </p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
});

export default FeedbackForm;
